import { useEffect, useState } from "react"

import { useFormContext } from "react-hook-form"

import { SelectElement } from "@front-shared/elements/select.element"

import { COVERAGE_CONFIG } from "../../../config/coverage.config"
import { LookupHelper } from "../../../helpers/lookup.helper"
import {
    ICoverageOverrideFormData,
    IOverrideDefaultData,
} from "../../../types/data.types"

export const InlinedOverrideFormTPATypeComponent: React.FunctionComponent<
    IInlinedOverrideFormTPATypeComponentProps
> = props => {
    const {
        register,
        unregister,
        setValue,
        watch,
        control,
        formState: { errors },
    } = useFormContext()

    const tpaName = watch("thirdPartyAdministratorName")
    const [previousTpaName, setPreviousTpaName] = useState<string | undefined>(
        props.defaultData.form.thirdPartyAdministratorName || "",
    )

    // The idea here is to clear existing TPA type when the TPA name is changed
    // This is because we always send TPA type when we send TPA name
    // (see related logic in mapCreationFormData in bulkOverrides.hooks.ts)
    useEffect(() => {
        if (
            previousTpaName ===
                props.defaultData.form.thirdPartyAdministratorName &&
            tpaName !== props.defaultData.form.thirdPartyAdministratorName
        ) {
            setValue(props.fieldDataKey, "")
        }

        setPreviousTpaName(tpaName)
    }, [tpaName])

    return (
        <SelectElement
            className="w-[136px]"
            name={props.fieldDataKey}
            size="small"
            renderedOptions={LookupHelper.getRenderedOptionsFromObjectMapped(
                COVERAGE_CONFIG.availableThirdPartyPayerTypeMapping,
            )}
            allowClear
            reactHookFormRegister={register}
            reactHookFormUnregister={unregister}
            reactHookFormControl={control}
            reactHookFormSet={setValue}
            reactHookFormErrors={errors}
            validations={{
                validate: {
                    conditionalRequire: (
                        _: boolean,
                        values: ICoverageOverrideFormData,
                    ) => {
                        return !!values.thirdPartyAdministratorName &&
                            !values.thirdPartyAdministratorType
                            ? "Type is required when Name is set"
                            : true
                    },
                },
            }}
            defaultValue={
                props.defaultData.form.thirdPartyAdministratorType
                    ? COVERAGE_CONFIG.availableThirdPartyPayerTypeMapping[
                          props.defaultData.form.thirdPartyAdministratorType
                      ]
                    : undefined
            }
            disabled={props.isDisabled}
            placeholder={props.mixedValuesPlaceholder}
        />
    )
}

interface IInlinedOverrideFormTPATypeComponentProps {
    defaultData: IOverrideDefaultData
    fieldDataKey: keyof ICoverageOverrideFormData
    isDisabled?: boolean
    mixedValuesPlaceholder?: string
}
